export default {"src":"/_next/static/media/game.dc1cd087.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};